import * as components from "./ComponentDocs";
import * as navigators from "./Navigators";
import * as gestures from "./GestureHandlerDocs";
import * as others from "./ExportDocs";

const corecomponents=["View","Fragment","FlatList","Switch","PopupView","DraggableView"];


export default {
    id:"vritra",
    docs:[
        {
            id:"corecomponents",
            name:"core components",
            entries:corecomponents.map(key=>components[key]),
        },
        {
            id:"usefulcomponents",
            name:"useful components",
            entries:Object.keys(components).filter(key=>!corecomponents.includes(key)).map(key=>components[key]),
        },
        {
            id:"navigators",
            entries:Object.values(navigators),
        },
        {
            id:"gesture handlers",
            entries:Object.values(gestures),
        },
        {
            id:"other exports",
            entries:Object.values(others),
        },
    ],
}
